import { HTMLFromRichText, PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_REPAYMENTS_CALCULATOR = 'PrismicGenericTemplateDataBodyRepaymentsCalc';

export interface GenericRepaymentsCalculatorPrimary {
  button_text?: TextFromRichText;
  button_link?: PrismicLink;
  calculator_heading?: TextFromRichText;
  disclaimer?: TextFromRichText;
  graph_heading?: TextFromRichText;
  radio_tooltip_content?: HTMLFromRichText;
  result_body?: TextFromRichText;
  result_heading?: TextFromRichText;
  show_graph?: boolean;
}

export interface GenericRepaymentsCalculatorContent {
  __typename: typeof GENERIC_REPAYMENTS_CALCULATOR;
  primary: GenericRepaymentsCalculatorPrimary;
}
